import { Stack, Typography } from "@mui/material";
import React from "react";
import { StepOneCommon } from "../StepOneCommon";

interface StepOneProps {
  fromImport: boolean;
}

export const StepOne: React.FC<StepOneProps> = ({ fromImport }) => {
  function renderImportCopy() {
    return (
      <Stack spacing={2} marginBottom={2}>
        <Typography variant="h6" fontWeight={600}>
          Let's get started importing your configuration to Bindplane.
        </Typography>

        <Typography>
          We&apos;ve provided some basic details for this configuration, just
          verify everything looks correct.
        </Typography>

        <Typography>
          When you&apos;re ready click Next to double check the configuration
          Yaml.
        </Typography>
      </Stack>
    );
  }

  function renderStandardCopy() {
    return (
      <Stack spacing={2} marginBottom={2}>
        <Typography variant="h6" fontWeight={600}>
          Let's get started adding your configuration to Bindplane.
        </Typography>

        <Typography>
          An OpenTelemetry configuration is a YAML file that&apos;s used to
          configure your OpenTelemetry collectors. It&apos;s made up of
          receivers, processors, connectors, and exporters that are organized
          into one or more data pipelines.
        </Typography>

        <Typography>
          If you&apos;re not familiar with the structure of these
          configurations, please take a look at our{" "}
          <a
            target="_blank"
            rel="noreferrer"
            href="https://github.com/observIQ/bindplane-agent/tree/main/config/google_cloud_exporter"
          >
            sample files
          </a>{" "}
          and the{" "}
          <a
            target="_blank"
            rel="noreferrer"
            href="https://opentelemetry.io/docs/collector/configuration/"
          >
            OpenTelemetry documentation
          </a>
          .
        </Typography>

        <Typography>
          Let&apos;s get started importing your OpenTelemetry configuration.
        </Typography>
      </Stack>
    );
  }

  return (
    <>
      <StepOneCommon
        renderCopy={fromImport ? renderImportCopy : renderStandardCopy}
      />
    </>
  );
};
